import { useLocalObservable } from 'mobx-react-lite';

import { Opponent } from '@gem/call/CallStore/Opponent/Opponent';
import { useCallContext } from '@gem/call/CallView/CallView.context';
import { ParticipantGridDisplayMode } from '@gem/call/Model/callModel.types';

interface IUseOpponentsListSelector {
  opponentsList: readonly Opponent[];
}

export const useOpponentsListSelector = (): readonly Opponent[] => {
  const context = useCallContext();

  return useLocalObservable<IUseOpponentsListSelector>(() => ({
    get opponentsList(): readonly Opponent[] {
      if (context.call.uiFeatures.participantGridDisplayMode === ParticipantGridDisplayMode.Admin) {
        return context.call.opponents.opponentList.filter((opponent: Opponent) => {
          const member = opponent.memberDevice?.member;
          return member?.isAdmin;
        });
      }
      return context.call.opponents.opponentList;
    },
  })).opponentsList;
};
